import { render, staticRenderFns } from "./MasterAccesories.vue?vue&type=template&id=4671fb84&"
import script from "./MasterAccesories.vue?vue&type=script&lang=js&"
export * from "./MasterAccesories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports